<template>
  <div
    v-if="option"
    class="gf_dropdown--item"
    :class="itemClass"
    :style="dropdownStylingOptionItem"
    @click="onSelected(option)">
    <div class="gf_dropdown--item-content" :style="{ width: !option.handleEdit ? '100%' : '' }">
      <div v-if="isIconForm" class="gf_dropdown--img">
        <i :class="['icon', option.icon]" />
      </div>
      <div v-else class="gf_dropdown--img">
        <svg
          :class="{ 'opacity-0': option.value !== defaultValue }"
          width="13"
          height="10"
          viewBox="0 0 13 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.56545 7.29855C4.48629 7.38405 4.35109 7.38405 4.27193 7.29855L2.04408 4.89228C1.84618 4.67853 1.50819 4.67853 1.31029 4.89228L0.814501 5.42778C0.637026 5.61947 0.637027 5.91547 0.814501 6.10716L3.6849 9.20744C4.0807 9.63494 4.75668 9.63494 5.15248 9.20744L12.1855 1.61116C12.363 1.41947 12.363 1.12347 12.1855 0.931779L11.6897 0.396278C11.4918 0.18253 11.1538 0.18253 10.9559 0.396278L4.56545 7.29855Z"
            fill="#00C853" />
        </svg>
      </div>
      <label
        class="gf_dropdown--item-name gf_truncate"
        :style="{ 'max-width': option.warning ? 'calc(100% - 45px)' : '' }"
        :title="option.name">
        {{ option.name }}
      </label>
      <i v-if="option.warning" class="icon icon-warn-triangle text-warning ml-4px gfDropDownSelect__warning" />
    </div>
    <Teleport to="#tooltips">
      <Tooltip :pointer="true" :width="'auto'" :top="-5" :delay="100" />
    </Teleport>
    <div
      v-if="option.handleEdit"
      v-tooltip.top="option.tooltipEdit || 'Edit Text'"
      class="gf_dropdown--handle__edit"
      @click.stop="onEdit($event, option)">
      <i class="icon icon-t-blog" />
    </div>
  </div>
</template>

<script lang="ts">
type DropdownOptionBasic = {
  name: string;
  value: string;
  icon: any;
  handleEdit: boolean;
  tooltipEdit: any;
  warning: any;
};

const DROPDOWN_TYPE = {
  SIMPLE_TYPE: 'simple',
  ICON_TYPE: 'icon',
};
import type { PropType } from 'vue';
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'GfDropdownBasicItem',
  props: {
    fType: {
      type: String,
      default: 'custom',
    },
    defaultValue: {
      type: [String, Number],
      default: '',
    },
    option: {
      type: Object as PropType<DropdownOptionBasic>,
      require: false,
      default: undefined,
    },
    itemClass: {
      type: String,
      default: '',
    },
    dropdownStylingOptionItem: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    isIconForm(): boolean {
      return this.fType === DROPDOWN_TYPE.ICON_TYPE;
    },
  },
  methods: {
    onSelected(option?: DropdownOptionBasic) {
      if (option) {
        this.$emit('selectItem', option);
      }
    },
    onEdit($event: any, option?: DropdownOptionBasic) {
      if (option) {
        this.$emit('editItem', { option, $event });
      }
    },
  },
});
</script>

<style scoped lang="scss">
@import '@/app/editor/scss/variables';
@import '@/core/themes/vendor/color';
@import '@/core/themes/vendor/variables';
@import '@/core/themes/vendor/mixins';
.gf_dropdown--item {
  height: $lg;
  position: relative;
}

.simple {
  width: 144px;

  .gf_dropdown--item {
    background: $black3 !important;
    height: $lg;
    padding: 4px !important;
    cursor: pointer;
  }

  .gf_dropdown--item:hover {
    background: $black2 !important;
    border-radius: $radius;
  }

  .gf_dropdown--img {
    width: 18px !important;
    margin-right: 6px !important;
    margin-left: 4px;
  }
}

.gf_dropdown--item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #494949;
  border-radius: $radius;
  padding: 7px;
  cursor: pointer;
  max-width: 200px;

  &-content {
    display: flex;
    width: calc(100% - 20px);
    align-items: center;
  }

  .gf_dropdown--item-name {
    width: max-content;
    max-width: calc(100% - 28px);
    height: 14px;
    font-style: normal;
    font-weight: $weight-500;
    font-size: 12px;
    line-height: 14px;
    color: $bg;
    cursor: pointer;
  }

  .gf_dropdown--img {
    @include flex-center;
    width: $sm;
    height: $sm;
    margin-right: 4px;
  }

  .gf_dropdown--handle__edit {
    @include flex-center;
    width: $md;
    height: $md;
    border-radius: $radius;
    visibility: hidden;

    &:hover {
      background: $black2;
    }
  }

  &:hover {
    .gf_dropdown--handle__edit {
      visibility: visible;
    }
  }
}

.opacity-0 {
  opacity: 0;
}

// Support for DropDown Sidebar Global Style
.gf_global-style__sidebar-option_dropdown-item {
  width: 100px;
  justify-content: left;
  padding: 8px;
  background-color: map-get($hybrid-shade-dark, '300');
  .gf_dropdown {
    &--img {
      margin-right: 8px;
    }
  }
  &:hover {
    background: map-get($hybrid-shade-dark, '200');
    border-radius: 3px;
  }
}

.gf_global-style__preview-option_dropdown-item {
  width: 109px;
  justify-content: left;
  padding: 8px;
  margin-bottom: 4px;
  background-color: map-get($hybrid-shade-dark, '300');
  .gf_dropdown {
    &--img {
      margin-right: 8px;
    }
  }
  &:hover {
    background: map-get($hybrid-shade-dark, '200');
    border-radius: 3px;
  }

  .gf_dropdown--img {
    height: 24px;
    width: 24px;
  }
}
// Support for DropDown Modal Apply Preset
.simple {
  .gf_apply-preset-modal__body__content__table__header-option_dropdown-item {
    background: map-get($hybrid-shade-light, '100') !important;
    justify-content: left;
    width: 135px;
    padding-left: 4px !important;
    &:hover {
      background: map-get($hybrid-shade-light, '300') !important;
      border-radius: 3px;
    }
    .gf_dropdown--item-name {
      color: map-get($text-light-mode, 'high-contrast') !important;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 500;
      padding: 0;
    }
  }
}
</style>
